import { FC } from "react";
import Logo from "shared/Logo/Logo";
import Navigation from "shared/Navigation/Navigation";
import MenuBar from "shared/MenuBar/MenuBar";

export interface MainNav1Props {
  className?: string;
}

const MainNav: FC<MainNav1Props> = ({ className = "" }) => {
  return (
    <div className={`nc-MainNav1 relative z-10 ${className}`}>
      <div className="px-4 lg:container py-2 relative flex justify-between items-center">
        <div className="flex justify-start items-center space-x-4 sm:space-x-10">
          <Logo />
        </div>
        <div className="hidden md:flex items-center">
          <Navigation />
        </div>

        <div className="flex lg:hidden items-center">
          <div className="px-0.5" />
          <MenuBar />
        </div>
      </div>
    </div>
  );
};

export default MainNav;
